// extracted by mini-css-extract-plugin
export default {"container":"ToInfo_container__Ibabm","img":"ToInfo_img__sQEx-","name":"ToInfo_name__Jq8WV"};